module.exports = __webpack_public_path__ + "DINNextLTPro-Black.ttf?a0eca24e36d3f816fad73f61673c0696";


//////////////////
// WEBPACK FOOTER
// ./src/assets/fonts/DINNextLTPro-Black.ttf
// module id = 1441
// module chunks = 0